import SetPassword from './set-password-container';

export default SetPassword;
